import { AutogenModelSalesperson, AutogenRowSalesperson } from "./autogen/AutogenModelSalesperson";

export class ModelSalesperson extends AutogenModelSalesperson<RowSalesperson> {
    constructor() {
        super(RowSalesperson);
    }
}

export class RowSalesperson extends AutogenRowSalesperson {
}